import type { RatingStatItem } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuRating/types'

/**
 * Чередует метрики клиники и врачей для одноколоночного (mobile) списка.
 */
export default function zipRatingStats(
  clinicStats: RatingStatItem[],
  doctorsStats: RatingStatItem[],
): RatingStatItem[] {
  const result: RatingStatItem[] = []
  const maxLength = Math.max(clinicStats.length, doctorsStats.length)
  let index = 0

  while (index < maxLength) {
    if (clinicStats[index]) {
      result.push(clinicStats[index])
    }

    if (doctorsStats[index]) {
      result.push(doctorsStats[index])
    }

    index += 1
  }

  return result
}
